<template>
	<div class="sale-detail-out-wrap">
		<div style="display: flex;justify-content: space-between;">
			<h2 class="title">出库记录</h2>
			<div 
				style="padding: 32px 16px 16px;font-size: 12px;text-decoration: underline;"
				@click="openAll"
				v-if="data.length > 0"
			>全部展开</div>
		</div>
		
		<van-collapse v-model="activeNames" v-if="data.length > 0">
		  <van-collapse-item v-for="(v, i) in data" :name="i + ''">
		    <template #title>
		      <div class="coll-item-title-main">
		      	<div>{{ v.batch }}</div>
						<!-- 出库时间 -->
		      	<div>{{ v.createtime_text }}</div>
		      </div>
		      
		      <div class="coll-item-title-part">
		      	<span>操作人: {{ v.operater ? v.operater : '-' }}</span>
		      </div>
		    </template>
		    <p> 批&nbsp;&nbsp;次&nbsp;&nbsp;号:{{ v.batch }}</p>
				
		    <div style="margin: 8px 0px;">
					<p>SKU:</p>
					<div 
						style="padding: 8px;" 
						v-for="(sku, sku_i) in v.list"
						:key="'sku' + sku_i"
					>
						<p>{{ sku.sku }}</p>
						<div style="display: flex;justify-content: space-between;font-size: 12px;">
							<div>仓库：{{ sku.warehouse }}</div>
							<div>出库数量：<span style="color: #18bc9c;">{{ sku.outstocknum }}</span></div>
						</div>
						<hr style="opacity: 0.5;" v-if="sku_i < (v.list.length - 1)">
					</div>
				</div>
		    <p> 操&nbsp;&nbsp;作&nbsp;&nbsp;人:{{ v.operater ? v.operater : '-' }}</p>
		    <p> 出库时间: {{ v.createtime_text }}</p>
		    <p> 备&emsp;&emsp;注: {{ v.remark }}</p>
		  </van-collapse-item>
		</van-collapse>
		<div
			v-else
			style="height: 50px;background-color: white;line-height: 50px;text-align: center;border-radius: 5px;"
		>暂无数据</div>
	
	</div>
</template>

<script>
	export default {
		components: {
		},
		props: {
			id: {
				type: [String, Number],
				default: () => {
					return 0;
				}
			},
		},
		data() {
		  return {
				activeNames: [],
				data: [],
		  };
		},
		watch: {},
		created() {
		  this.init();
		},
		mounted() {},
		methods: {
		  init() {
				this.getData();
			},
			getData() {
				this.$post(this.$api.stGetFaHuoOutlog, { id: this.id }).then((res) => {
					if (res.code === 1) {
						this.data = res.data;
					} else {
						this.$toast.fail(res.msg ? res.msg : '请求异常');
					}
				}).catch((err) => {
					this.$toast.fail(err);
				});
			},
			openAll() {
				for (let i in this.data) {
					if (!this.activeNames.includes(i)) {
						this.activeNames.push(i);
					}
				}
			},
		},
	}
</script>

<style lang="scss" scoped>
	.sale-detail-out-wrap {
		margin: 24px;
		border-radius: 5px;
		.title {
				margin: 0;
				padding: 32px 16px 16px;
				color: rgba(69, 90, 100, 0.6);
				font-weight: normal;
				font-size: 14px;
				line-height: 16px;
		}
		
		.coll-item-title-main {
			display: flex;
			justify-content: space-between;
		}
		
		.coll-item-title-part {
			span {
				margin-right: 8px;
				font-size: 12px;
				color: #a5a0a0;
			};
		}
	}
</style>